import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledNavLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-bottom: ${(p) => p.$nextToAvatar && p.theme.space[3]};
  width: ${(p) => p.theme.space[7]};
  height: ${(p) => p.theme.space[7]};
  border-radius: ${(p) => p.theme.radii.pill};
  background-color: ${(p) =>
    (p.$isSelected && p.theme.alias.shadow) || 'transparent'};

  &:hover {
    background-color: ${(p) => p.theme.alias.shadow};
  }

  &:focus-visible {
    box-shadow: ${(p) => p.theme.shadows.focusAlt};
  }
`;

export const StyledNavLinkButton = styled(StyledNavLink).attrs({
  as: 'button',
})``;
